"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.player = exports.server = void 0;
const vec3_1 = require("vec3");
function randomInt(low, high) {
    return Math.floor(Math.random() * (high - low) + low);
}
const server = function (serv, settings) {
    serv.gameMode = settings.gameMode;
    serv.difficulty = settings.difficulty;
    const mcData = serv.mcData;
    // todo make logic general
    const waterBlocks = new Set([mcData.blocksByName.water.id]);
    if (mcData.blocksByName.flowing_water !== undefined) {
        waterBlocks.add(mcData.blocksByName.flowing_water.id);
    }
    async function findSpawnZone(world, initialPoint) {
        let point = initialPoint;
        while ((await (world.getBlockStateId(point))) === 0 && point.y > 0) {
            point = point.offset(0, -1, 0);
        }
        let i = 0;
        const LIMIT = 600;
        while (true) {
            i++;
            const p = await world.getBlockType(point);
            if (!waterBlocks.has(p) || i > LIMIT) {
                break;
            }
            point = point.offset(1, 0, 0);
        }
        // i guess infinite loop is not possible here
        while ((await world.getBlockStateId(point)) !== 0) {
            point = point.offset(0, 1, 0);
        }
        return point;
    }
    serv.getSpawnPoint = async (world) => {
        if (serv.spawnPoint)
            return serv.spawnPoint;
        return findSpawnZone(world, new vec3_1.Vec3(randomInt(0, 30), 81, randomInt(0, 30)));
    };
};
exports.server = server;
const player = function (player, serv) {
    player.prevGameMode = 255;
    player.gameMode = serv.gameMode;
    player.findSpawnPoint = async () => {
        player.spawnPoint = await serv.getSpawnPoint(player.world);
    };
    player._client.on('settings', ({ viewDistance }) => {
        player.view = viewDistance;
        player.sendRestMap();
    });
};
exports.player = player;
